import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom';

import NotificationPanel from '../../components/UI/NotificationPanel/NotificationPanel';
import InterviewSchedulerList from '../../container/Recruiter/RecruiterInterviewDetails/InterviewSchedulerList/InterviewSchedulerList';
import InterviewCreateEvent from '../../container/Recruiter/InterviewCreateEvent/InterviewCreateEvent';
import InterviewPreview from '../../components/Recruiter/InterviewPreview/InterviewPreview';
import './InterviewSchedulerLayout.css';

/**
* @desc Layout for Interview Scheduler
* @version 
* @author Lakshmikanth 
*/
class InterviewSchedulerLayout extends Component {
  render() {
    return (
      <div className="interview-scheduler-container">
        {/* <NotificationPanel 
        notificationText={"SYNC YOUR WORK CALENDER TO YOUR INTERVIEW SCHEDULER"}
        notificationLinkUrl={"/"}
        notificationLinkText={"SYNC"} /> */}
        <div className="interview-scheduler-wrapper">       
          <Switch>
            <Route exact path="/recruiter/interview-scheduler/create-event" component={InterviewCreateEvent} />  
            <Route exact path="/recruiter/interview-scheduler" component={InterviewSchedulerList} />
            <Route exact path="/recruiter/interview-scheduler/preview" component={InterviewPreview} />        
          </Switch>
        </div>
      </div>
    );
  }
}

export default InterviewSchedulerLayout;



// WEBPACK FOOTER //
// ./src/hoc/layout/InterviewSchedulerLayout.js